import { Link } from 'react-router';
import { patchApi } from '../api/client';
import { fullWhen, shortWhen } from '../lib/format';
import { Icon } from '../lib/icons';
import { useData } from '../lib/useData';
import { Card } from './ui';

/**
 * Call history's Patches: "Patch with Sam · 12 min", newest first, each linking back to its
 * conversation. Shows nothing when there are none (or Patches aren't on).
 */
export function PatchHistory({ domain }: { domain: string }) {
  const h = useData(() => patchApi.history(domain).catch(() => ({ patches: [] })), [domain], { live: false });
  const list = h.data?.patches ?? [];
  if (!list.length) return null;
  return (
    <Card title="Patches">
      <ul className="patch-history" aria-label="Patches you were in" data-private="">
        {list.map((p) => (
          <li key={p.id}>
            <Icon name="headset" size={17} />
            <Link to={`/t/${encodeURIComponent(domain)}/messages/${encodeURIComponent(p.conversationId)}`}>{p.text}</Link>
            <time dateTime={p.startedAt} title={fullWhen(p.startedAt)}>
              {shortWhen(p.startedAt)}
            </time>
          </li>
        ))}
      </ul>
    </Card>
  );
}
